import { api } from 'shared/api'

import { ApplicationsSchemas } from './schemas'

export const ApplicationsApi = {
  // Applications
  fetchAccounts: api.base.createGet({
    url: '/application/accounts',
    schemas: ApplicationsSchemas.fetchAccounts,
  }),
  fetchSettingsForm: api.base.createGet({
    url: '/application/getSettingsForm',
    schemas: ApplicationsSchemas.fetchSettingsForm,
  }),
  fetch: api.base.createGet({
    url: '/application/list',
    schemas: ApplicationsSchemas.fetchList,
  }),
  fetchItem: api.base.createGet({
    url: '/application/get',
    schemas: ApplicationsSchemas.fetchItem,
  }),
  create: api.base.createPost({
    url: '/application/create',
    schemas: ApplicationsSchemas.createApplication,
  }),
  update: api.base.createPost({
    url: '/application/update',
    schemas: ApplicationsSchemas.updateApplication,
  }),
  uninstall: api.base.createPost({
    url: '/application/uninstall',
    schemas: ApplicationsSchemas.uninstallApplication,
  }),
  publish: api.base.createPost({
    url: '/application/publish',
    schemas: ApplicationsSchemas.publishApplication,
  }),
  updateSettings: api.base.createPost({
    url: '/application/updateSettings',
    schemas: ApplicationsSchemas.updateSettings,
  }),
  getReport: api.base.createGet({
    url: '/application/getReport',
    schemas: ApplicationsSchemas.getReport,
  }),
  uploadAvatar: api.base.createPost({
    url: '/application/uploadImage',
    schemas: ApplicationsSchemas.uploadAvatar,
  }),

  // App Store
  fetchApplicationByHash: api.account.createGet({
    url: '/appStore/get',
    schemas: ApplicationsSchemas.fetchApplicationByHash,
  }),

  installApplication: api.account.createPost({
    url: '/appStore/install',
    schemas: ApplicationsSchemas.installApplication,
  }),

  // Account Apps
  fetchInstalledApps: api.account.createGet({
    url: '/accountApps/getInstalledApps',
    schemas: ApplicationsSchemas.fetchInstalledApps,
  }),
  fetchUsesList: api.account.createGet({
    url: '/accountApps/getUsesList',
    schemas: ApplicationsSchemas.fetchUsesList,
  }),
  getChangelogs: api.account.createGet({
    url: '/accountApps/getChangeLogs',
    schemas: ApplicationsSchemas.getChangelogs,
  }),
  updateVersion: api.account.createPost({
    url: '/accountApps/updateVersion',
    schemas: ApplicationsSchemas.updateVersion,
  }),
  getAppAction: api.account.createGet({
    url: '/accountApps/getAppAction',
    schemas: ApplicationsSchemas.getAppAction,
  }),
  loadAppSource: api.account.createGet({
    url: '/accountApps/loadAppSource',
    schemas: ApplicationsSchemas.loadAppSource,
  }),
  fetchAppTriggers: api.account.createGet({
    url: '/accountApps/getTriggers',
    schemas: ApplicationsSchemas.fetchAppTriggers,
  }),
  getAppActions: api.account.createGet({
    url: '/accountApps/getAppActions',
    schemas: ApplicationsSchemas.getAppActions,
  }),
}
